import {LeasingType} from "./LeasingType";
import {IEntity} from "../../../typescript-plugin/entities/IEntity";
import {Key} from "../../../typescript-plugin/entities/Key";

export class Leasing implements IEntity{

    public type:LeasingType;
    public name:string;
    public picture:string;
    public pricePerDay:number;
    public pricePerHalfDay:number;
    public pricePerKm:number;

    public length:number;
    public width:number;
    public height:number;
    public seats:number;
    public payload:number;
    public volume:number;

    public Key(): Key {
        return new Key({type:this.type});
    }

    public Serialize(): {} {
        return this.ToPersistable();
    }

    public Deserialize(data: {}): void {
        this.ToEntity(data);
    }

    public ToPersistable(): {} {
        return {
            type: this.type,
            name: this.name,
            picture:this.picture,
            pricePerDay: this.pricePerDay,
            pricePerHalfDay: this.pricePerHalfDay,
            pricePerKm: this.pricePerKm,
            length: this.length,
            width: this.width,
            height: this.height,
            seats: this.seats,
            payload: this.payload,
            volume: this.volume,
        }
    }

    public ToEntity(data: {}): void {
        this.type = data['type'];
        this.name = data['name'];
        this.picture = data['picture'];
        this.pricePerDay = data['pricePerDay'];
        this.pricePerHalfDay = data['pricePerHalfDay'];
        this.pricePerKm = data['pricePerKm'];
        this.length = data['length'];
        this.width = data['width'];
        this.height = data['height'];
        this.seats = data['seats'];
        this.payload = data['payload'];
        this.volume = data['volume'];
    }

    public AsFake():Leasing{
        this.type = LeasingType.TrafficFourgonL2H1;
        this.name = "Traffic Fourgon L2H1";
        this.picture = "src/hello.png";
        this.pricePerDay = 60;
        this.pricePerHalfDay = 35;
        this.pricePerKm = 0.2;
        this.length = 2937;
        this.width = 1256;
        this.height = 1562;
        this.seats = 3;
        this.payload = 1280;
        this.volume = 6;
        return this;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/Leasing.ts